<template>
    <v-navigation-drawer :expand-on-click="false" mini-variant-width="85" :width="pcOnly ? 300 : 335" overlay-color="#000" overlay-opacity="0.65" app :permanent="pcOnly" fixed v-model="show" :temporary="phoneOnly" :color="phoneOnly ? '#6e1016' : undefined" :dark="phoneOnly" class="app-menu" :class="{'app-menu--phone': phoneOnly}">
        <div v-if="phoneOnly" class="drawer-header pt-5 pt-lg-7">
            <div class="logo-wrapper d-flex align-center justify-space-between px-5" :style="iosSafeArea ? `padding-top: 40px!important` : ''">
                <logo white />

                <v-btn large class="mb-2 ms-2" icon text color="white" @click.prevent="show=false">
                    <v-icon size="24" color="white">mdi-menu</v-icon>
                </v-btn>
            </div>
        </div>

        <v-list-item v-else class="py-2" :class="{'px-4': pcOnly}">
            <v-list-item-content>
                <logo :height="76" />
            </v-list-item-content>

        </v-list-item>


        <v-list  class="mt-3" :class="{'px-3': pcOnly}" nav dense>

            <!-- <v-divider class="mb-3" /> -->
            <v-list-item v-for="(item, i) in drawerRoutes" v-show="!item.pcOnly || pcOnly" :key="i" link :to="item.to" :href="item.href" :target="item.href ? '_system' : ''" exact :class="listItemClass(item.name)" class="rounded px-3">
                <v-list-item-icon>
                    <v-badge small :value="!!item.chip && self[item.chip]" :content="self[item.chip]" overlap light :color="item.chipColor ? item.chipColor : 'primary'" right bordered class="font-weight-bold menu-item-badge">
                        <v-icon>{{ $route.name === item.name ? item.activeIcon || item.icon : item.icon }}</v-icon>
                    </v-badge>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title :style="$route.name === item.name ? 'font-weight: 500' : 'font-weight: 400!important'" style="font-size: 0.95rem; line-height: 1.4rem">{{item.text}}</v-list-item-title>
                </v-list-item-content>

            </v-list-item>

            <v-divider inset class="my-2"></v-divider>

            <v-list-item v-if="phoneOnly" @click="show = false; logoutDialog = true">
                <v-list-item-icon>
                    <v-icon>mdi-arrow-left-circle-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

        </v-list>
        <logout-dialog v-model="logoutDialog" />
    </v-navigation-drawer>

</template>

<script>
import GlobalMethods from '@/helpers/global-methods'
import GlobalComputed from '@/helpers/global-computed'
import Logo from './logo'
import drawerRoutes from '@/helpers/links'
import LogoutDialog from '../default/dialogs/logout'

export default {
    name: 'app-menu',
    props: ['value'],
    data(){
        return {
            self: this,

            show: false,
            logoutDialog: false,
        }
    },
    components: {
        Logo,
        LogoutDialog,
        // StoreBadge
    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        }
    },
    computed: {
        ...GlobalComputed,
        walletDisabled(){
            return !this.appData.enable_app_w;
        },
        drawerRoutes(){
            let routes = this.isAuthed ? (this.isTeacher ? drawerRoutes.auth.teacher : drawerRoutes.auth.student) : drawerRoutes.guest;
            const self = this;
            return routes.filter(route=>{
                if (route.hide){
                    return !self[route.hide];
                }
                return true;
            })
        },
    },
    methods: {
        listItemClass(name){
            const active = this.$route.name === name;
            if (this.phoneOnly){
                return {'v-list-item--active app-menu__item--active': active};
            }
            return {'v-list-item--active primary white--text': active};
        },
        openRoute(route){
            this.show = false;
            this.$router.push(route);
        },
        openProfile(){
            let isProfile = this.$route.name === 'profile' && this.$route.params.id == this.user.id;
            if (!isProfile){
                this.$router.push({name: 'profile', params: {id: this.user.id}});
            }
        },
        ...GlobalMethods
    }
}
</script>

<style lang="scss" scoped>
    .app-menu{
        will-change: auto!important;
        // border: none!important;
        
        .v-list-item{/*  */
            border-left: 3px solid transparent;
            &.v-list-item--active{
                
            }

        }
        .theme--light.v-list-item--active:before{
            opacity: 0!important;
        }
        .theme--light.v-list-item--active:hover:before, .theme--light.v-list-item:focus:before{
            opacity: 0.08!important;
        }
    }

    .app-menu--phone{
        .app-menu__item--active{
            background-color: rgba(255, 255, 255, 0.1) !important;
            // border-left-color: rgba(255, 255, 255, 0.85) !important;

            ::v-deep .v-list-item__title,
            ::v-deep .v-list-item__icon .v-icon{
                color: rgba(255, 255, 255) !important;
            }
        }
        .app-menu__item--active::before{
            opacity: 0 !important;
        }
        ::v-deep .v-list-item__title,
        ::v-deep .v-list-item__icon .v-icon{
            color: rgba(255, 255, 255, 0.75) !important;
        }
    }
</style>
<style lang="scss">
    .v-navigation-drawer__border{
        // display: none;
    }
</style>
